import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import useSWR from "swr";

import { FileUploader } from "devextreme-react";
import { Form, Item, GroupItem, Label } from "devextreme-react/form";
import { getUserId } from "../../Utils/helper";
import useFetch from "../../Hooks/useFetch";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import ActionNotifications from "../../Components/ActionNotifications";
import { purchaseTypes, deadlineTypes } from "../POPage/variables";
import useGetAllApprovedVendorList from "../../Hooks/useGET/useGetAllApprovedVendorList";
import "./styles.css";

export default function PONewPage({ props }) {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    [state, setState] = useState({
      vendorName: "",
      vendorContact: "",
      vendorEmail: "",
      vendorAddress: "",
      fein: "",
      deadlineType: 0,
      deadlineDate: "",
      requestedDate: "",
      requestorContactNumber: "",
      urgencyJustification: "",
      poAdditionalEmails: "",
      additionalInfo: "",
      productDescription: "",
      productQuantity: "",
      productCost: "",
      shippingLocationId: 0,
      shippingAttn: "",
      provideShippingAccountOnPO: false,
      isAS9100: false,
      approvedVendorId: null,
      shippingRequirements: "",
      relatedEquip: "",
      purchaseType: 0,
      otherType: "",
      addingForUser: false,
      userId: "",
      isInstallationRequired: false,
      installationRequirements: "",
      projectName: "",
      billingCode: "",
      otherBilling: "",
      priorAuthorizationForm: "",
      quoteDocument: "",
      emailChain: "",
      users: [],
      locations: [],
      billingCodes: [],
      highCost: false,
      total: "",
      notifications: [],
    }),
    { data: userData, error: userError } = useSWR(
      `${apiBaseURL}/api/users/all`,
    ),
    { data: locationData, error: locationError } = useSWR(
      `${apiBaseURL}/api/DeliveryLocation`,
    ),
    { data: typeData, error: typeError } = useSWR(
      `${apiBaseURL}/api/Project/BillingCodes`,
    ),
    { allSuppliers } = useGetAllApprovedVendorList(),
    scrollPosRef = useRef(null);

  //{ data: typeData, error: typeError } = useSWR(!props.admin ? `${apiBaseURL}/api/Hours/billing?locationId=${state.location}&taskId=${state.task}` :
  //    `${apiBaseURL}/api/Hours/billing/user?userId=${params.userId}&locationId=${state.location}&taskId=${state.task}`);
  useEffect(() => {
    if (userData && typeData && locationData) {
      if (userData.data && typeData.data && locationData.data) {
        setState({
          ...state,
          billingCodes: typeData?.data.map((x) => ({
            label: `${x.billingCode} - ${x.description}`,
            value: x.billingCode,
            projectId: x.projectId,
          })),
          // billingCodes: typeData.data.map((x) => ({ label: x, value: x })),
          locations: locationData?.data,
          users: userData?.data.map((x) => ({
            label: `${x.firstName} ${x.lastName}`,
            value: x.id,
          })),
        });
      }
    }
  }, [userData, locationData, typeData]);

  useEffect(() => {
    if (scrollPosRef.current == null) return;

    const y = scrollPosRef.current;

    scrollPosRef.current = null;

    // Let DevExtreme finish rendering → THEN restore scroll
    window.requestAnimationFrame(() => {
      window.scrollTo({
        top: y,
        left: 0,
        behavior: "auto", // no smooth animation, just snap back
      });
    });
  }, [
    state.isAS9100,
    state.otherBilling,
    state.isInstallationRequired,
    state.purchaseType,
  ]);

  const onUploadDataClick = async (e) => {
    const body = {
      userId: state.userId === "" ? getUserId() : state.userId,
      RequestorContactNumber: state.requestorContactNumber,
      VendorName: state.vendorName,
      VendorContact: state.vendorContact,
      VendorEmail: state.vendorEmail,
      VendorAddress: state.vendorAddress,
      DeadlineType: state.deadlineType,
      DeadlineDate: state.deadlineDate,
      UrgencyJustification: state.urgencyJustification,
      POAdditionalEmails: state.poAdditionalEmails,
      AdditionalInfo: state.additionalInfo,
      ShippingLocationId: state.shippingLocationId,
      ShippingAttn: state.shippingAttn,
      ProvideShippingAccountOnPO: state.provideShippingAccountOnPO,
      IsAS9100: state.isAS9100,
      ApprovedVendorId: state.approvedVendorId,
      PurchaseType: state.purchaseType,
      IsInstallationRequired: state.isInstallationRequired,
      InstallationRequirements: state.installationRequirements,
      BillingCode: state.billingCode,
      OtherBilling: state.otherBilling,
      Total: state.total,
      poStatus: 0,
    };
    if (body.DeadlineType !== 2) {
      //body.DeadlineDate = new Date();      //removed this bc Kristen wanted people to be able to set the deadline date for any deadline type
      body.UrgencyJustification = "N/A";
    }
    if (!body.IsInstallationRequired) {
      body.InstallationRequirements = "N/A";
    }
    if (!body.IsAS9100) {
      body.ApprovedVendorId = null;
    }
    console.log(body);
    setState({ ...state, showSpinner: true });
    let response = null;
    response = await fetch.post(`${apiBaseURL}/api/PurchaseOrders`, body);
    console.log(response);
    if (response.success) {
      if (response?.data.statusCode) {
        const id = response?.data?.data;
        const toasts = response?.data.messeges.map((message) => ({
          isMessageInGDStanding: response?.data?.statusCode,
          message: "Purchase Order Requested Sucessfully",
        }));

        if (state.quoteDocument !== "") {
          console.log(state.quoteDocument);
          let quoteResponse = "";
          for (let i = 0; i < state.quoteDocument.length; i++) {
            let formData = new FormData();
            formData.append("OrderId", id);
            formData.append("Image", state.quoteDocument[i]);
            quoteResponse = await fetch.postFile(
              `https://atlasboard.wsu-idp.org/backend/api/attachment`,
              formData,
            );
            console.log(quoteResponse);
            if (quoteResponse.success) {
              if (quoteResponse?.data.statusCode) {
                const toasts = quoteResponse?.data?.messeges.map((message) => ({
                  isMessageInGDStanding: quoteResponse?.data?.statusCode,
                  message,
                }));

                setState({
                  ...state,
                  showSpinner: false,
                  vendorName: "",
                  vendorContact: "",
                  vendorEmail: "",
                  vendorAddress: "",
                  fein: "",
                  deadlineType: 0,
                  deadlineDate: "",
                  requestedDate: "",
                  requestorContactNumber: "",
                  urgencyJustification: "",
                  poAdditionalEmails: "",
                  additionalInfo: "",
                  productDescription: "",
                  productQuantity: "",
                  productCost: "",
                  shippingLocationId: 0,
                  shippingAttn: "",
                  provideShippingAccountOnPO: false,
                  isAS9100: false,
                  approvedVendorId: null,
                  shippingRequirements: "",
                  relatedEquip: "",
                  purchaseType: 0,
                  otherType: "",
                  addingForUser: false,
                  userId: "",
                  isInstallationRequired: false,
                  installationRequirements: "",
                  projectName: "",
                  billingCode: "",
                  otherBilling: "",
                  priorAuthorizationForm: "",
                  quoteDocument: "",
                  emailChain: "",
                  total: "",
                  notifications: [].concat(state.notifications, toasts),
                });
              }
            } else {
              let notifications = [
                {
                  isMessageInGDStanding: false,
                  message:
                    "An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.",
                },
              ];
              //not clearing form
              setState({
                ...state,
                showSpinner: false,
                vendorName: "",
                vendorContact: "",
                vendorEmail: "",
                vendorAddress: "",
                fein: "",
                deadlineType: 0,
                deadlineDate: "",
                requestedDate: "",
                requestorContactNumber: "",
                urgencyJustification: "",
                poAdditionalEmails: "",
                additionalInfo: "",
                productDescription: "",
                productQuantity: "",
                productCost: "",
                shippingLocationId: 0,
                shippingAttn: "",
                provideShippingAccountOnPO: false,
                isAS9100: false,
                approvedVendorId: "",
                shippingRequirements: "",
                relatedEquip: "",
                purchaseType: 0,
                otherType: "",
                addingForUser: false,
                userId: "",
                isInstallationRequired: false,
                installationRequirements: "",
                projectName: "",
                billingCode: "",
                otherBilling: "",
                priorAuthorizationForm: "",
                quoteDocument: "",
                emailChain: "",
                total: "",
                notifications: [].concat(state.notifications, notifications),
              });
            }
          }
        } else {
          let notifications = [
            {
              isMessageInGDStanding: response?.data.statusCode,
              message: "Purchase Order Requested Sucessfully",
            },
          ];

          setState({
            ...state,
            showSpinner: false,
            notifications: [].concat(state.notifications, notifications),
          });
        }
      } else {
        let notifications = [
          { isMessageInGDStanding: false, message: response?.data.messeges[0] },
        ];

        setState({
          ...state,
          showSpinner: false,
          notifications: [].concat(state.notifications, notifications),
        });
      }
    } else {
      let notifications = null;

      if (Array.isArray(response.errors)) {
        notifications = response.errors
          ? response.errors
          : [
              {
                isMessageInGDStanding: false,
                message: "An error has occured. Please try again later.",
              },
            ];
      } else {
        notifications = [
          {
            isMessageInGDStanding: false,
            message:
              "An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.",
          },
        ];
      }

      setState({
        ...state,
        showSpinner: false,
        notifications: [].concat(state.notifications, notifications),
      });
    }
    return null;
  };

  const checkCost = () => {
    if (state.productQuantity !== "" && state.productCost !== "") {
      if (state.productQuantity * state.productCost >= 10000) {
        let notification = [];
        if (state.highCost === false) {
          notification = [
            {
              isMessageInGDStanding: false,
              message: "Prior Authorization Form Required for Purchase",
            },
          ];
        }
        setState({
          ...state,
          highCost: true,
          notifications: [].concat(state.notifications, notification),
        });
      } else {
        setState({ ...state, highCost: false });
      }
    }
  };

  const renderContent = () => {
    const formFieldDataChanged = (e) => {
      if (e.dataField === "deadlineType") {
        setState({ ...state, deadlineType: e.value });
      } else if (e.dataField === "productQuantity") {
        setState({ ...state, productQuantity: e.value });
        checkCost();
      } else if (e.dataField === "productCost") {
        setState({ ...state, productCost: e.value });
        checkCost();
      } else if (e.dataField === "purchaseType") {
        scrollPosRef.current = window.scrollY || window.pageYOffset || 0;
        setState((prev) => ({
          ...prev,
          purchaseType: e.value,
        }));
      } else if (e.dataField === "isInstallationRequired") {
        scrollPosRef.current = window.scrollY || window.pageYOffset || 0;
        setState((prev) => ({
          ...prev,
          isInstallationRequired: e.value,
        }));
      } else if (e.dataField === "isAS9100") {
        scrollPosRef.current = window.scrollY || 0;

        setState((prev) => ({
          ...prev,
          isAS9100: e.value,
          approvedVendorId: e.value ? prev.approvedVendorId : null,
          vendorName: e.value ? prev.vendorName : "",
          vendorContact: e.value ? prev.vendorContact : "",
          vendorEmail: e.value ? prev.vendorEmail : "",
          vendorAddress: e.value ? prev.vendorAddress : "",
        }));
        console.log(state.approvedVendorId);
      } else if (e.dataField === "addingForUser") {
        setState({
          ...state,
          addingForUser: e.value,
          userId: e.value === false ? "" : state.userId,
        });
      } else if (e.dataField === "billingCode") {
        let stateValues = { ...state };
        const selectedBC = state.billingCodes.find((x) => x.value === e.value);
        //add these back eventually
        //stateValues = { ...stateValues, projectName: selectedBC.projectId, billingCode: selectedBC.code }
        //setState(stateValues)
      } else {
        return null;
      }
    };
    console.log(state.approvedVendorId);
    console.log(state.vendorName);
    console.log(state.vendorContact);
    console.log(state.vendorAddress);

    return (
      <>
        <div className="row g-0">
          <Form
            formData={state}
            onFieldDataChanged={formFieldDataChanged}
            scrollingEnabled={false}
            repaintChangesOnly={true}
            focusStateEnabled={false}
          >
            <Item
              dataField="addingForUser"
              editorType="dxCheckBox"
              visible={getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da"}
              editorOptions={{
                text: "Requesting PO for another user?",
                elementAttr: {
                  class: "checkbox",
                },
              }}
            >
              <Label text={" "} />
            </Item>
            <Item
              dataField="userId"
              editorType="dxSelectBox"
              editorOptions={{
                items: state.users,
                valueExpr: "value",
                displayExpr: "label",
                searchEnabled: true,
                placeholder: "Type or Select...",
              }}
              visible={state.addingForUser}
            >
              <Label text="Select User" />
            </Item>
            <Item dataField="requestorContactNumber" editorType="dxNumberBox">
              <Label text="Requestors Contact Number" />
            </Item>
            <Item itemType="group" caption="Vendor Information" colCount={2}>
              <Item
                dataField="isAS9100"
                editorType="dxCheckBox"
                editorOptions={{
                  text: "Requires AS9100 compliance?",
                  elementAttr: {
                    class: "checkbox",
                  },
                }}
              >
                <Label text={" "} />
              </Item>

              <Item
                dataField="approvedVendorId"
                visible={state.isAS9100}
                editorType="dxSelectBox"
                editorOptions={{
                  items: allSuppliers,
                  valueExpr: "id",
                  displayExpr: "name",
                  searchEnabled: true,
                  placeholder: "Select approved vendor...",
                  onValueChanged: (e) => {
                    const vendor = allSuppliers.find((v) => v.id === e.value);
                    if (!vendor) return;

                    setState((prev) => ({
                      ...prev,
                      approvedVendorId: vendor.id,
                      vendorName: vendor.name,
                      vendorContact: vendor.contact,
                      vendorEmail: vendor.email,
                      vendorAddress: vendor.address,
                    }));
                  },
                }}
              >
                <Label text="Approved Vendor Name" />
              </Item>

              <Item dataField="vendorName" visible={!state.isAS9100}></Item>
              <Item dataField="vendorContact">
                <Label text="Vendor Phone Number" />
              </Item>
              <Item dataField="vendorEmail"></Item>
              <Item dataField="vendorAddress"></Item>
              <Item dataField="fein" visible={false}>
                <Label text="FEIN" />
              </Item>
              <Item
                dataField="deadlineType"
                editorType="dxSelectBox"
                editorOptions={{
                  items: deadlineTypes,
                  valueExpr: "value",
                  displayExpr: "text",
                  placeholder: "Select...",
                }}
              ></Item>
              <Item
                dataField="deadlineDate"
                editorType="dxDateBox"
                editorOptions={{
                  width: "100%",
                  type: "date",
                  displayFormat: "shortdate",
                  showClearButton: true,
                  useMaskBehavior: true,
                  placeholder: "mm/dd/yyyy",
                }}
              >
                <Label text="Desired Deadline Date" />
              </Item>
              <Item
                dataField="urgencyJustification"
                visible={state.deadlineType === 2}
                editorType="dxTextArea"
              >
                <Label text="Justification for Urgency" />
              </Item>
              <Item dataField="poAdditionalEmails">
                <Label text="Contacts to CC" />
              </Item>
              <Item
                dataField="additionalInfo"
                editorType="dxTextArea"
                colSpan={2}
              >
                <Label text="Description of Purchase" />
              </Item>
            </Item>
            <Item itemType="group" caption="Required Information" colCount={2}>
              <Item
                dataField="productDescription"
                editorType="dxTextArea"
                editorOptions={{ height: 90 }}
                colSpan={2}
                visible={false}
              >
                <Label text="Provide a brief description of the product" />
              </Item>
              <Item
                dataField="productQuantity"
                editorType="dxNumberBox"
                visible={false}
                editorOptions={{ format: "#" }}
              >
                <Label text="Quantity" />
              </Item>
              <Item
                dataField="productCost"
                editorType="dxNumberBox"
                visible={false}
                editorOptions={{ format: "$#.##", placeholder: "$" }}
              >
                <Label text="Price per Item" />
              </Item>
              <Item
                dataField="shippingLocationId"
                editorType="dxSelectBox"
                editorOptions={{
                  items: state.locations,
                  valueExpr: "id",
                  displayExpr: "location",
                  searchEnabled: true,
                  placeholder: "Type or Select...",
                }}
              >
                <Label text="Delivery Location" />
              </Item>
              <Item dataField="shippingAttn">
                <Label text="Shipping Attention" />
              </Item>
              <Item
                dataField="provideShippingAccountOnPO"
                editorType="dxCheckBox"
                editorOptions={{
                  // text: "Provide Shipping Acct on PO?",
                  text: "Does quote include shipping cost?",
                  elementAttr: {
                    class: "checkbox",
                  },
                }}
              >
                <Label text={" "} />
              </Item>
              <Item
                dataField="purchaseType"
                editorType="dxSelectBox"
                editorOptions={{
                  items: purchaseTypes,
                  valueExpr: "id",
                  displayExpr: "value",
                  placeholder: "Select...",
                  focusStateEnabled: false,
                  openOnFieldClick: true,
                }}
              >
                <Label text="Type of Purchase" />
              </Item>

              <Item
                dataField="shippingRequirements"
                editorType="dxTextArea"
                editorOptions={{ height: 90 }}
                visible={false}
              >
                <Label text="Are there any addditional shipping requirements?" />
              </Item>
              <Item dataField="relatedEquip" visible={false}>
                <Label text="Related Equipment (if applicable)" />
              </Item>
              <Item
                dataField="otherType"
                /*visible={state.purchaseType === 2}*/ visible={false}
              >
                <Label text="Please Specify Type" />
              </Item>
              <Item
                dataField="isInstallationRequired"
                editorType="dxCheckBox"
                editorOptions={{
                  text: "Special Install Requirements?",
                  elementAttr: {
                    class: "checkbox",
                  },
                  focusStateEnabled: false,
                }}
              >
                <Label text={" "} />
              </Item>
              <Item
                dataField="installationRequirements"
                editorType="dxTextArea"
                editorOptions={{ height: 90 }}
                cssClass={!state.isInstallationRequired ? "dx-hidden" : ""}
              >
                <Label text="Specify Requirements:" />
              </Item>
              <Item itemType="empty" visible={!state.isInstallationRequired} />
              <Item
                dataField="billingCode"
                editorType="dxSelectBox"
                editorOptions={{
                  items: state.billingCodes,
                  valueExpr: "value",
                  displayExpr: "label",
                  searchEnabled: true,
                  placeholder: "Type or Select...",
                }}
              >
                <Label text="ATLAS Billing Code" />
              </Item>
              <Item dataField="projectName" visible={false}></Item>
              <Item dataField="otherBilling">
                <Label text="Funding (if different than ATLAS)" />
              </Item>
              <Item
                dataField="total"
                editorType="dxNumberBox"
                editorOptions={{ format: "$#.##" }}
              />
            </Item>
          </Form>
          <FileUploader
            dataField="priorAuthorizationForm"
            selectButtonText="Upload Prior Authorization Form"
            uploadMode="useForm"
            /*visible={state.highCost}*/ visible={false}
            onValueChange={(event) =>
              setState({ ...state, priorAuthorizationForm: event[0] })
            }
          ></FileUploader>
          <FileUploader
            visible={true}
            dataField="quoteDocument"
            selectButtonText="Upload Quote Document"
            uploadMode="useForm"
            multiple
            onValueChange={(event) =>
              setState({ ...state, quoteDocument: event })
            }
          ></FileUploader>
          <FileUploader
            visible={false}
            dataField="emailChain"
            selectButtonText="Upload Email Chain Document"
            uploadMode="useForm"
            onValueChange={(event) =>
              setState({ ...state, emailChain: event[0] })
            }
          ></FileUploader>
          <button
            onClick={onUploadDataClick}
            className="button mt-1"
            disabled={state.showSpinner}
          >
            {state.showSpinner ? (
              <FontAwesomeIcon icon={faSpinner} className="fa-spin" size="lg" />
            ) : (
              `Submit Request`
            )}
          </button>
        </div>
      </>
    );
  };

  return (
    <div className="px-lg-4 content">
      <ActionNotifications arrayOfToasts={state.notifications} />
      <div className="row my-2 page-content">
        <div id="link">
          <Link className="hoverLinkText gray" to="/purchaseOrders" end>
            <h5 className="white">&#x2190; All POs</h5>
          </Link>
        </div>
        <h1 className="white">Submit Purchase Order Request</h1>
      </div>
      <div className="contentBox page-content">{renderContent()}</div>
    </div>
  );
}
